import type { Playlist, Song } from '../../interfaces/types';
import { getAlbumPath, getEducationPath } from '../../utils/getPublicPath';

export enum EducationTypesEnum {
  DEGREE = 'DEGREE',
  COURSE = 'COURSE',
  EXAM = 'EXAM',
}

/* ----- Bachelor's Degree ----- */
const BSC_CS = {
  name: 'BSC_CS',
  artist: 'Bachelor of Science in Computer Science (B.Sc. CS)',
  length: '2022 – 2025',
  description:
    'Pursuing Bachelor of Science in Computer Science at the College of Computer Science and Information Technology under Swami Ramanand Teerth Marathwada University. CGPA: 9.25',
  types: [EducationTypesEnum.DEGREE],
  // link: 'https://www.srtmun.ac.in/',
  imageUrl: getEducationPath('cisco/logo1.jpg'),
  skills: [],
} as Song;

/* ----- Higher Secondary Certificate (HSC) ----- */
const HSC = {
  name: 'HSC',
  artist: 'Higher Secondary Certificate (HSC)',
  length: 'March 2022',
  description:
    'Completed HSC from Swami Vivekanand Mahavidyalaya, Shirur Tajband under Maharashtra State Board. Scored 69.33%.',
  types: [EducationTypesEnum.EXAM],
  // link: 'https://mahahsscboard.in/',
  imageUrl: getEducationPath('hsc/logo.jpg'),
  skills: [],
} as Song;

/* ----- Secondary School Certificate (SSC) ----- */
const SSC = {
  name: 'SSC',
  artist: 'Secondary School Certificate (SSC)',
  length: 'March 2020',
  description:
    'Completed SSC from Sant Tukaram Vidyalaya, Jagalpur (Bk) under Maharashtra State Board. Scored 85.80%.',
  types: [EducationTypesEnum.EXAM],
  // link: 'https://mahahsscboard.in/',
  imageUrl: getEducationPath('ssc/logo.jpg'),
  skills: [],
} as Song;

/* ----- IoT Course (Cisco) ----- */
const CISCO_IOT = {
  name: 'CISCO_IOT',
  artist: 'Cisco Networking Academy',
  length: '2023',
  description:
    'Achieved A+ performance in Cisco’s IoT-based course, showcasing expertise in IoT technology and its real-world applications.',
  types: [EducationTypesEnum.COURSE],
  link: 'https://www.credly.com/badges/47870717-9e0b-412d-b99b-899848099e10/print',
  imageUrl: getEducationPath('cisco/logo.png'),
  certificate: 'https://drive.google.com/file/d/1UnaesSymDCyobCVDDCQsHHNhAwjPbKFa/view?usp=sharing',
  skills: [],
} as Song;

/* ----- Export Education Playlist ----- */
export const Education = {
  name: 'EDUCATION',
  description: 'Academic background and certifications.',
  songs: [BSC_CS, HSC, SSC, CISCO_IOT],
  color: '#74725f',
  getImage(lang) {
    return getAlbumPath('Education-cover', lang, 'png');
  },
  filters: [EducationTypesEnum.DEGREE, EducationTypesEnum.COURSE, EducationTypesEnum.EXAM],
} as Playlist;
